import { useContext, useMemo } from 'react';
import { AppMode } from '../../../enums/AppMode';
import { GlobalConfigurationContext } from '../../context/GlobalConfigurationContext';
import { isVendorMode } from '../../Vendor';

interface AppModeValue {
  isEmbeddedMode: boolean;
}

interface Props {
  strict?: boolean;
}

/**
 * Checks if the app is in embedded mode, which rules over certain UI details
 * and behaviors that are specific to a particular app mode, whether
 * standalone or embedded.
 *
 * @param strict - if true, only considers the global context app mode, otherwise
 *                 includes other conditions such as if it's in vendor mode
 */
const useAppMode = (props?: Props): AppModeValue => {
  const { appMode } = useContext(GlobalConfigurationContext);

  const { strict = true } = props || {};

  const value = useMemo(
    () => ({
      isEmbeddedMode:
        appMode === AppMode.Embedded || (!strict && isVendorMode()),
    }),
    [appMode, strict]
  );

  return value;
};

export default useAppMode;
